import React from 'react'
import styled from 'styled-components'
import placeholder from '../../assets/images/courses_empty.svg'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
    cardTitle: {
        margin: '24px 0 8px',
        fontSize: '32px',
        color: '#BCBCCB'
    },
    cardSubtitle: {
        fontSize: '22px',
        color: '#BCBCCB'
    }
})

const Holder = styled.div`
    width: 100%;
    height: 418px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const Image = styled.img`
    max-width: 318px;
`

const CardPlaceholder = () => {
    const classes = useStyles()
    return (
        <Holder>
            <Image src={placeholder} />
            <Typography gutterBottom variant="body1" component="p" className={classes.cardTitle} color={'gray'}>
                Você ainda não possui cursos
            </Typography>
        </Holder>
    )
}

export default CardPlaceholder